import { RoutesConstants } from '@/main/routes/routesConstants';
import { isNullUndefinedEmpty } from '../utils';
import {
  PREVIOUS_ROUTE,
  SELECTED_CANCELLED_PARTS_REASSIGN,
  STORAGE_REFRESH_TOKEN,
  STORAGE_TOKEN
} from './constants';

export const saveArrayStorage = (key: string, value: Array<any>) =>
  localStorage.setItem(key, JSON.stringify(value));

export const saveStorage = (key: string, value: object) =>
  localStorage.setItem(key, JSON.stringify(value));

export const saveStringStorage = (key: string, value: string) =>
  localStorage.setItem(key, value);

export const getStorage = (key: string) => {
  const item = localStorage.getItem(key);
  if (item) {
    return JSON.parse(item);
  }
  return null;
};

export const getStringStorage = (key: string) => {
  return localStorage.getItem(key) || '';
};

export const clearStorage = () => {
  return localStorage.clear();
};

export const removeKeyStorage = (key: string) => localStorage.removeItem(key);

export const getStorageObject = (key: string) => {
  try {
    const keyObject = localStorage.getItem(key);

    if (keyObject) {
      return JSON.parse(keyObject);
    }
  } catch {
    return {};
  }
};

export const getStorageString = (key: string) => {
  return localStorage.getItem(key) || '';
};

export const getPreviousRoute = () => {
  const url = getStorageString(PREVIOUS_ROUTE);
  const urlCustom = url !== undefined ? url.split('#')[1] : undefined;
  if (
    urlCustom !== undefined &&
    urlCustom !== '' &&
    urlCustom !== '/' &&
    !urlCustom.includes(RoutesConstants.login) &&
    !urlCustom.includes(RoutesConstants.notFound)
  ) {
    removeKeyStorage(PREVIOUS_ROUTE);
    return urlCustom;
  }
  return '';
};

export const isUserAuthenticated = () => {
  const userToken = getStringStorage(STORAGE_TOKEN);
  return !isNullUndefinedEmpty(userToken);
};

export const logout = () => {
  removeKeyStorage(STORAGE_TOKEN);
  removeKeyStorage(STORAGE_REFRESH_TOKEN);
  removeKeyStorage(PREVIOUS_ROUTE);
  removeKeySessionStorage(SELECTED_CANCELLED_PARTS_REASSIGN);
};

export const saveSessionStorage = <T extends object>(key: string, value: T) =>
  sessionStorage.setItem(key, JSON.stringify(value));

export const getSessionStorage = <T = unknown>(key: string): T | null => {
  const item = sessionStorage.getItem(key);
  if (item) {
    return JSON.parse(item) as T;
  }
  return null;
};

export const removeKeySessionStorage = (key: string) => {
  sessionStorage.removeItem(key);
};
